/** Minimal external store for useSyncExternalStore (AGENT.md D-004). */
export class Store<T> {
  private listeners = new Set<() => void>();
  constructor(private state: T) {}

  get = (): T => this.state;

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  /** Whether anything is subscribed (lets producers skip work nobody sees). */
  get hasListeners(): boolean {
    return this.listeners.size > 0;
  }

  set(next: T): void {
    if (Object.is(next, this.state)) return;
    this.state = next;
    for (const l of [...this.listeners]) l();
  }

  update(recipe: (s: T) => T): void {
    this.set(recipe(this.state));
  }
}
